import {hr} from 'date-fns/locale';

// date-fns 2 has no Bosnian locale. Calendar conventions are shared with hr;
// month and weekday names below use Bosnian rather than Croatian spelling.
const months = [
    'januar',
    'februar',
    'mart',
    'april',
    'maj',
    'juni',
    'juli',
    'august',
    'septembar',
    'oktobar',
    'novembar',
    'decembar',
];
const formattingMonths = [
    'januara',
    'februara',
    'marta',
    'aprila',
    'maja',
    'juna',
    'jula',
    'augusta',
    'septembra',
    'oktobra',
    'novembra',
    'decembra',
];
const days = ['nedjelja', 'ponedjeljak', 'utorak', 'srijeda', 'četvrtak', 'petak', 'subota'];
export const bs: Locale = {
    ...hr,
    code: 'bs',
    localize: {
        ...hr.localize!,
        month: (index: number, options?: {width?: string; context?: string}) => {
            const value = (options?.context === 'formatting' ? formattingMonths : months)[index];
            if (options?.width === 'narrow') return value[0];
            if (options?.width === 'abbreviated') return months[index].slice(0, 3);
            return value;
        },
        day: (index: number, options?: {width?: string}) => {
            if (options?.width === 'narrow') return days[index][0];
            if (options?.width === 'short') return days[index].slice(0, 2);
            if (options?.width === 'abbreviated') return days[index].slice(0, 3);
            return days[index];
        },
    },
};
